import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";

/***
 Here we create a CallbackQueueManager class object
 This allows to store callbacks in a queue array with a timeout of 0 to be executed on next render call

 returns:
 @this: our CallbackQueueManager class object
 ***/
export var CallbackQueueManager = /*#__PURE__*/function () {
  function CallbackQueueManager() {
    _classCallCheck(this, CallbackQueueManager);

    this.clear();
  }
  /***
   Clears our queue array (used on init)
   ***/


  _createClass(CallbackQueueManager, [{
    key: "clear",
    value: function clear() {
      this.queue = [];
    }
    /***
     Adds a callback to our queue list with a timeout of 0
       params:
     @callback (function): the callback to execute on next render call
     @keep (bool): whether to keep calling that callback on each rendering call or not (act as a setInterval). Default to false
       returns:
     @queueItem: the queue item. Allows to keep a track of it and set its keep property to false when needed
     ***/

  }, {
    key: "add",
    value: function add(callback) {
      var _this = this;

      var keep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var queueItem = {
        callback: callback,
        keep: keep,
        timeout: null // keep a reference to the timeout so we can safely delete if afterwards

      };
      queueItem.timeout = setTimeout(function () {
        _this.queue.push(queueItem);
      }, 0);
      return queueItem;
    }
    /***
     Executes all callbacks in the queue and remove the ones that have their keep property set to false.
     Called at the beginning of each render call
     ***/

  }, {
    key: "execute",
    value: function execute() {
      var _this2 = this;

      // execute queue callbacks list
      this.queue.map(function (entry) {
        if (entry.callback) {
          entry.callback();
        } // clear our timeout


        clearTimeout(_this2.queue.timeout);
      }); // remove all items that have their keep property set to false

      this.queue = this.queue.filter(function (entry) {
        return entry.keep;
      });
    }
  }]);

  return CallbackQueueManager;
}();